import { API } from "./axios"
import { AxiosError } from "axios"
import { APIResponse } from "./interfaces"
import { ERROR_CODE_API_UNAUTHORIZED } from "./error-codes"
import { authStorageAdapter } from "../auth/storageAdapter"
import { DefaultLoginPageURL } from "../vars/url"

function redirectToPage(page = "/") {
  if (typeof window !== "undefined") {
    window.location.href = page
  }
}

export async function axiosFetcher<JSON = unknown>(url: string): Promise<JSON> {
  return await API.get<JSON>(url)
    .then((res) => res.data)
    .catch((err: AxiosError<APIResponse>) => {
      if (
        !err?.response?.data?.success &&
        err?.response?.data?.codeError === ERROR_CODE_API_UNAUTHORIZED
      ) {
        return err.response.data as JSON
      }
      throw err
    })
}

export async function axiosFetcherUser<JSON = unknown>(
  url: string
): Promise<JSON> {
  return await API.get<JSON>(url)
    .then((res) => {
      let apiResponse = res.data as APIResponse

      return apiResponse?.data
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        authStorageAdapter.clearToken()

        // redirect to login page
        redirectToPage(DefaultLoginPageURL)
        return
      }

      if (err?.response?.data && !err?.response?.data?.success) {
        throw new FetchError({
          message: err?.response?.data?.errorMessage,
          response: err?.response?.data,
          data: {
            message: err?.response?.data?.errorMessage,
          },
        })
      } else {
        let errAxios = err as AxiosError

        throw new FetchError({
          message: errAxios.message,
          response: errAxios?.response,
          data: {
            message: errAxios.message,
          },
        })
      }
    })
}

export class FetchError extends Error {
  response: Response
  data: {
    message: string
  }

  constructor({
    message,
    response,
    data,
  }: {
    message: string
    response: any
    data: {
      message: string
    }
  }) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError)
    }

    this.name = "FetchError"
    this.response = response
    this.data = data ?? { message: message }
  }
}
